var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["favorite-button", { active: _vm.active }],
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.toggle($event)
        }
      }
    },
    [_c("f-sprite-icon", { attrs: { "icon-link": _vm.iconUrl } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }